import {
  getRelativeFontSize,
  inputLabelRequiredColor,
  mediumFont,
  theme,
} from "../../../utils/styles";

const customSelectStyles = {
  selectStyle: {
    width: "100%",
    minWidth: "200px",
    borderRadius: "10px",
    background: "#2f2f2f",
    color: "#ffffff",

    boxShadow: "none",
    ".MuiOutlinedInput-notchedOutline": { border: 0 },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },

    "& .MuiSelect-outlined": {
      border: "none",
      position: "relative",
      padding: "11px 12px",
      borderRadius: "10px",
      color: "#ffffff",

      "&::placeholder": {
        ...mediumFont,
        color: "#f2f2f2",
      },
    },
    "& .MuiSelect-icon": {
      color: "#ffffff",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
  },
  nameField: {
    color: "#202730",
    marginLeft: "6px",
    ...mediumFont,
    fontSize: getRelativeFontSize(3),
    "& .MuiFormLabel-asterisk": {
      color: inputLabelRequiredColor,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(2),
    },
  },
  icon: {
    fill: "#202730",
  },
  errorStyle: {
    ...mediumFont,
    fontSize: getRelativeFontSize(1),
    marginLeft: "6px",
    color: "#d32f2f",
  },
  errorTextField: {
    "& .MuiSelect-outlined": {
      border: "1px solid #d32f2f",
      borderRadius: "10px",
      position: "relative",
      padding: "11px 12px",
      color: "#FFFFFF",
    },
  },
} as const;

export default customSelectStyles;
